import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {ImportReferenceTypeService} from 'application/import-reference-type/services';
import {resolveColumns} from 'application/facility/util/resolveColumns';
import { action } from 'mobx';

@applicationContext
class ImportReferenceTypeViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const importReferenceTypeService = new ImportReferenceTypeService(rootStore.application.baasic.apiClient);
        const permissions = rootStore.userStore.user.permissions;
        let actions = {};
        let routes = {};

        if(permissions.importReferenceSection !== undefined && permissions.importReferenceSection.includes("Full")){
            actions = {
                onDelete: (item) => this.deleteResource(item),
                onEdit: async (item) => routes.edit(item)
            };
            routes = {
                create: () => rootStore.routerStore.goTo(
                    'master.app.main.import-reference-type.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => i.id === item.id,() => item.name);
                    return rootStore.routerStore.goTo(
                        'master.app.main.import-reference-type.edit',
                        { id: item.id }
                    )
                },
            };
        }

        super(rootStore, {
            name: 'import-reference',
            autoInit: true,
            routes: routes,
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await importReferenceTypeService.find({
                            ...params
                        });

                        return response.data;
                    },
                    delete: async (item) => {
                        await importReferenceTypeService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                 {
                    key: 'name',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.NAME'
                },
            ]),
            actions: actions
        }));
    } 

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('IMPORT_REFERENCE_TYPE.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default ImportReferenceTypeViewStore;
